<div class="survey-info-step-content">
  <div class="survey-info-step-title">{{ getLangValue(stepData?.title) }}</div>
  <div class="survey-info-step-description" [innerHTML]="getLangValue(stepData?.description)"></div>
</div>
